
// internal imports
import Service from "core/decorators/Service";
import Logger from "core/util/Logger";
import LocalCacheService from "./LocalCache.service";

const cookieMap = {"strictly necessary":["language","store"], "functional":["view:table:rows","view:rows:count",":usertags","_pendo_"]} 

@Service()
export default class IntelStorageService extends LocalCacheService {

	constructor() {
		super();
	}

	public put(key: string, payload: object, cacheName?: string): boolean {
		//const wapJson ={"consent_date":"2020-07-16T23:52:02.164Z","categories":{"ad targeting":false,"analytics":true,"functional":false,"strictly necessary":true}, "consent_type":1}
		//localStorage.setItem("_wap_user_consent", JSON.stringify(wapJson));
		
		var skipStorage = false;
		// check if user cookie settings and disable 
		var userConsent = JSON.parse(localStorage.getItem("_wap_user_consent"));
		if (userConsent) {
			var data = userConsent.categories;

			Object.keys(data).forEach(function(category) {
				if (!data[category] && cookieMap[category]) {
					for (let cname of cookieMap[category]) {
						if(key.includes(cname)) {
							skipStorage = true;
							break;
						}
					}
				}
			  });
		} else {
			var userConsentStr = localStorage.getItem("_wap_user_consent_str");
			if (userConsentStr) {
				// skip storage if key category is not in user consent string
				let keyCategory = '';

				Object.keys(cookieMap).forEach(function(mapCat) {
					if (mapCat!='strictly necessary') {
						for (let cname of cookieMap[mapCat]) {
							if(key.includes(cname)) {
								keyCategory = mapCat;
								break;
							}
						}
					}
				});

				if (keyCategory) {
					let consent = userConsentStr.split(',');
					if (consent.indexOf(keyCategory)<0) {
						skipStorage = true;
					}
				}
			}
		}
		
		if (!skipStorage) return super.put(key,payload,cacheName);

		return false;
	}

	

	public getServiceId(): string {
		return "intelrco";
	}
}



// WEBPACK FOOTER //
// ./src/core/service/cache/impl/IntelLocalCache.service.ts